var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress__steps"},_vm._l((_vm.stepsData),function(ref,index){
var content = ref.content;
var isCurrent = ref.isCurrent;
var isCompleted = ref.isCompleted;
return _c('Step',{key:(content + "-" + index),staticClass:"progress__step",attrs:{"content":content,"is-current":isCurrent,"is-completed":isCompleted}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }